import { ConfigStateService, SessionStateService } from '@abp/ng.core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

import 'src/core/services/auth/oauth-service.extensions';
import { CAConfigStateService } from 'src/core/services/config/ca-config-state.service';

@Component({
  selector: 'ca-external-main',
  templateUrl: './external-main.component.html',
  styleUrls: ['./external-main.component.scss'],
  standalone: false,
})
export class ExternalMainComponent implements OnInit {
  get hasLoggedIn(): boolean {
    return this.oAuthService.hasValidAccessToken();
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private oAuthService: OAuthService,
    private configStateService: CAConfigStateService,
    private abpConfigStateService: ConfigStateService,
    private sessionStateService: SessionStateService
  ) {
    const refreshToken = this.route.snapshot.queryParams.refreshToken;
    const redirectTo = this.route.snapshot.queryParams.redirectTo;
    const language = this.route.snapshot.queryParams.lang;
    const fragments = redirectTo ? redirectTo.split('/') : [];

    document.body.classList.add('external-view');

    const localization = this.abpConfigStateService.getOne('localization');
    const isLanguageValid = localization.languages.some(x => x.uiCultureName === language);
    const defaultLanguage = 'en';

    this.sessionStateService.setLanguage(isLanguageValid ? language : defaultLanguage);

    if (this.hasLoggedIn) {
      this.router.navigate(fragments);

      return;
    }

    if (refreshToken) {
      this.oAuthService
        .fetchTokenUsingGrant('refresh_token', {
          refresh_token: refreshToken,
        })
        .then(result => {
          this.configStateService.refreshAppState().subscribe(res => {
            this.router.navigate(fragments);
          });
        });

      return;
    }
  }

  ngOnInit(): void {}
}
